export interface DeleteSystemBatchMenuRequest {
  id: string
  revision: number
}

export function DeleteSystemBatchMenuRequestToJSON(
  value: DeleteSystemBatchMenuRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
